'use strict';

angular.module('risevision.common.components.userstate')
  .factory('canAccessApps', ['$q', '$state',
    'userState', 'userAuthFactory', 'urlStateService',
    function ($q, $state, userState, userAuthFactory, urlStateService) {
      return function (signup, allowReturn, redirectTo) {
        return userAuthFactory.authenticate(false)
          .then(function () {
            if (!userState.isRiseVisionUser()) {
              return $q.reject();
            }
          })
          .catch(function () {
            var newState;

            if (!userState.isLoggedIn()) {
              if (signup) {
                newState = 'apps.auth.createaccount';
              } else {
                newState = 'apps.auth.unauthorized';
              }
            } else if ($state.get('apps.auth.unregistered')) {
              newState = 'apps.auth.unregistered';
            }
            var state = redirectTo ? redirectTo : urlStateService.get();
            if (newState) {
              $state.go(newState, {
                state: state
              }, {
                reload: true,
                location: allowReturn ? true : 'replace'
              });

              return $q.reject('unauthenticated');
            }
          });
      };
    }
  ]);
